import { render } from "./FileSelectorButton.vue?vue&type=template&id=5124a686"
import script from "./FileSelectorButton.vue?vue&type=script&lang=ts"
export * from "./FileSelectorButton.vue?vue&type=script&lang=ts"
script.render = render

export default script